import { render, staticRenderFns } from "./InvUserList.vue?vue&type=template&id=21669e3f&scoped=true&"
import script from "./InvUserList.vue?vue&type=script&lang=js&"
export * from "./InvUserList.vue?vue&type=script&lang=js&"
import style0 from "./InvUserList.vue?vue&type=style&index=0&id=21669e3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21669e3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
